module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/th/2-d8448b6a6b0dbf13fc519e103da3882a.jpg";